import SWorker from 'simple-web-worker'
import axios from 'axios'
import * as types from './mutation-types'
import {router} from '../main'

const GET_CATEGORIES = "GetCategories"
const GET_ITEMS = "GetItems"
const GET_MEMBER = "GetMember"
const SAVE_CART = "SaveCart"
const GET_MEMBER_CARTS = "GetMemberCarts"

axios.defaults.headers.post['Content-Type'] = 'application/json';

/*
 -------------
    // API -- User, Categories, Items
 -------------

export const initUser = async ({commit, dispatch, getters, state}) => {*/
export const initUser = async ({commit, dispatch, getters, state}) => {
    if (!!state.user && !!state.user.validToken) {
        return state.user;
    }

    let _user = getFromStorage(localStorage, "_marketuser");
    // console.log('initUser > ', _user);
    if (!!_user) {
        _user = JSON.parse(_user);
        // console.log('valid token? > ', _user.validToken);
        let hastoken = await dispatch('checkUserToken', _user);
        // console.log(hastoken);
        if (!hastoken) {
            dispatch('appLoaded')
            return false;
        } else {
            _user.validToken = true;
        }
        if (!_.has(_user, 'itemsOrdered') && !!_user.mid) {
            _user.itemsOrdered = await fetchItemsOrdered(_user.mid);
        }
        // initIdleTimer()
    }
    // checkForUserCart()
    commit('INIT_USER', _user);
    
    //let _cart = getFromStorage(sessionStorage, "_marketcart");
    let _cart = getFromStorage(localStorage, "_marketcart");//_cart = JSON.parse(_cart);
    
    //if (!!_cart && !!_cart.mid && !!_user.mid)
    if (!!_cart)
    {
        _cart = JSON.parse(_cart);
        //alert("_cart.mid="+_cart.mid);
        //alert("_user.mid="+_user.mid);

        //if (parseInt(_cart.mid)===parseInt(_user.mid)) {
            commit('INIT_CART', _cart);
        //} else {
            //removeFromStorage(sessionStorage, "_marketcart")
            //removeFromStorage(localStorage, "_marketcart")
        //}
    }
    return _user;
}

// checkForUserCart() {
//     let _cart = getFromStorage(sessionStorage, "_marketuser");
// }
export const initSettings = ({commit, dispatch}) => 
{
    let settings = getFromStorage(localStorage, "_marketSettings") // storageSupport() ? sessionStorage.getItem("_marketcategories") || null : null;
    settings = JSON.parse(settings);
    //alert("se="+settings.borderMode);
    commit('INIT_SETTINGS', settings);
};

export const initCategories = async ({commit, dispatch}) => {
    let categories = getFromStorage(sessionStorage, "_marketcategories") // storageSupport() ? sessionStorage.getItem("_marketcategories") || null : null;
    if (!categories) {
        let API = `https://api.mis-implants.com/api/market?value=categories`;
        axios.get(API).then(response => {
            // console.log("[GET_CATEGORIES] RESPONSE >> ", response);
            if (!!response.data) {
                let cats = JSON.parse(response.data);
                // cats.unshift({
                //     Id: 111101,
                //     name: 'Simple Campaign',
                //     sort: 0,
                //     parent: -1,
                //     children: []
                // })


                cats.unshift({
                    Id: 111100,
                    name: 'New',/* New */
                    sort: 0,
                    parent: -1,
                    children: []
                });
                ///alert("added new");

                _.remove(cats, { Id: 85});

                _.each(cats, cat => {
                    cat.name = cat.name.trim();
                    cat.src = '/img/categories/' + cat.name.replace(/[\s]*&[\s]*/g, '_and_').replace(/\+/g, '_plus').replace(/ /g, '_') + '.png';  
                })
                //  console.log("final cats >> ", cats);

                // save categories to local storage if available
                setToStorage(sessionStorage, '_marketcategories', JSON.stringify(cats), 30);
                commit('INIT_CATEGORIES', cats);
            }
            return response;
        }, response => {
            // console.log('categories response err > ', response);
            return { 'err': response }
        }, { headers: { 'Access-Control-Allow-Origin': '*' } })
    } else {
        commit('INIT_CATEGORIES', JSON.parse(categories));
    }
}
export const initItems = async ({commit, dispatch, getters}, items) => {
    // console.log("[initItems]");
    let _items = getFromStorage(sessionStorage, "_marketitems");
    if (!_items) {
        let dataFromWorker = await loadItems()
        // console.log('dataFromWorker >> ', dataFromWorker);
        if (!!dataFromWorker) {
            //setItems(JSON.parse(dataFromWorker), commit, getters)
            setItems(dataFromWorker, commit, getters);////vvv
        }
    }
    else {
        /*
            Fetch Items from Cache
            Load updated items from server in the background.
        */
        let parsedItems = JSON.parse(_items);
        commit('INIT_ITEMS', parsedItems);
        loadItemsInBackground(parsedItems.length, commit, getters)
    }
}
export const checkUserToken = async ({commit, dispatch}, u) => {
    // console.log('checkUserToken >> ', u);
    if (!u.mid) {
        return false
    }
    let API = `https://api.mis-implants.com/api/auth?token=${u.token}==&mid=${u.mid}`;
    return axios.get(API).then(response => {
        // console.log("response from token check >> ", response);
        if (!!response.data) {
            return eval(response.data.toLowerCase())
        }
        return false
    })

}

export const setBorderMode = ({commit}, mode) => {
    commit('SET_BORDER_MODE', mode);
}

export const signInUser = async ({commit, dispatch}, user) => {
    let errmsg = "Login failed, please try again.";
    let API = `https://api.mis-implants.com/api/auth?u=${user.u}&p=${user.p}&a=market`;
    return axios.get(API).then(response => {
        // console.log("response from sign in >> ", response);
        if (!!response.data) {
            let res = JSON.parse(response.data);
            if (!!res.err) {
                return res.err;
            } else {
                commitUser(res);
            }
        }
    }, response => {
        // console.log("err from sign in >> ", response);
        return errmsg;
    }, {headers: {'Access-Control-Allow-Origin': '*'}})

    async function commitUser(res) {
        // console.log("commit user >> ", res);

        let _user = {
            first_name: res.first_name,
            last_name: res.last_name,
            country: res.country,
            mid: res.mid,
            token: res.token,
            email: res.email,
            flag: null,
            itemsOrdered: [],
            timestamp: new Date()
        }
        if (!!res.country) {
            _user.flag = await fetchUserFlag(_user.country);
        }
        if (!!_user.mid) {
            _user.itemsOrdered = await fetchItemsOrdered(_user.mid);
        }
        //
        //
        setToStorage(localStorage, '_marketuser', JSON.stringify(_user), 3);
        //
        //
        commit('INIT_USER', _user);
        //router.push({ name: 'home'})
        router.push({ path: '/categories/New'})
    }
}

export const saveSettings = ({commit, dispatch, state}) => {
    var settings={

    }
}

export const userSignout = ({commit, dispatch}) => {
    removeFromStorage(localStorage, "_marketuser");
    commit('INIT_USER', null);
    router.push({ name: 'login'})
}
export const appLoaded = ({commit}) => {
    commit('APP_LOADED')
}
/*
 -------------
    // OVERLAY
 -------------
*/
export const toggleOverlay = async ({commit, dispatch, state}, type) => {

    let act = !!state.overlay.active ? 'HIDE_OVERLAY' : 'SHOW_OVERLAY';
     commit(act, type, await dispatch('hideShelf'));
     return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 200)
    })

}
export const showOverlay = async ({commit, dispatch}, type) => {

    commit('SHOW_OVERLAY', type);
}
export const hideOverlay = async ({commit}) => {
    commit('HIDE_OVERLAY');
}

/*
 -------------
    // SHELF
 -------------
*/
var shelfTimer = 0;
export const toggleShelf = async ({commit, dispatch}, type) => {
    // console.log("TOGGLE SHELF");
    dispatch('bindCartMouseMove');
    clearTimeout(shelfTimer);
    type = (!!type && typeof type==='string') ? type : 'cart';
    commit('TOGGLE_SHELF', type);
     return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 400)
     })
}
export const changeShelfType =  ({commit}, type) => {
    clearTimeout(shelfTimer);
    commit('CHANGE_SHELF_TYPE', type);
}
export const showShelf = async ({commit, dispatch}) => {
    dispatch('bindCartMouseMove');
    commit('SHOW_SHELF', await dispatch('hideOverlay'));
    return new Promise((resolve, reject) => {
        setTimeout(() => {

            resolve()
        }, 400)
    })
}
export const hideShelf = async ({commit}, animate) => {
    commit('HIDE_SHELF', animate);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 0)
    })
}
export const bindCartMouseMove = ({commit, dispatch, state, getters}) => {
    // console.log('bind mouse events to shelf');
    clearTimeout(shelfTimer);
    var cart = document.getElementById('cartWrap'),
    time = 154000;//////dubi cart hide auto 10000
    if (!!cart) {
        cart.removeEventListener('mouseleave', mouseLeaveHandler);
        cart.removeEventListener('mouseenter', mouseEnterHandler);
    }
    if (!!getters.isDevice) {
        timedShelfClose(dispatch, time);
    }
    else {
        setTimeout(function () {
            if (!state.mousepos || (state.mousepos.y < 130 || state.mousepos.y > 630)) {
                timedShelfClose(dispatch, time);
            }
            if (!!cart) {
                cart.addEventListener('mouseleave', mouseLeaveHandler);
                cart.addEventListener('mouseenter', mouseEnterHandler);
            }
        }, 500)
    }

    function mouseLeaveHandler() {
        timedShelfClose(dispatch, time);
    }
    function mouseEnterHandler() {
        clearTimeout(shelfTimer);

    }
    function timedShelfClose(dispatch, time) {
        shelfTimer = setTimeout(function () {
            dispatch('hideShelf');
        }, time)
    }
}
export const updateMousePos = ({commit}, e) => {
    commit('UPDATE_MOUSE_POS', { x: e.clientX, y: e.clientY});
}

/*
 -------------
    // SEARCH FILTER
 -------------
*/
export const searchFilterString = ({commit, dispatch, state}, filter_string) => {
    if (!!state.shelf.active) {
        dispatch('hideShelf');
    }
    if (!!state.overlay.active) {
        dispatch('hideOverlay');
    }

    // console.log('commit SEARCH_FILTER_STRING >>> ', filter_string);
    commit('SEARCH_FILTER_STRING', filter_string);
}


/*
 -------------
    // DRAG N DROP
 -------------
*/
export const updateItemInLimbo = async ({commit, dispatch, state}, item) => {
    if (!!item && !state.shelf.active) {
        await dispatch('showShelf');
    }
    commit('UPDATE_ITEM_IN_LIMBO', item);
}


/*
 -------------
    // CART ACTIONS
 -------------
 payload >>
 > item
 > showCart (BOOL) *optional
*/
export const getLocalStorageCart = async ({commit, dispatch, state}) => {
    let _cart = getFromStorage(localStorage, "_marketcart");//
    _cart = JSON.parse(_cart);
    return _cart;
}

export const addToCart = async ({commit, dispatch, state}, payload) => {
    let item = payload.item;
    if (!payload.dontShowCart && !state.shelf.active) {
        await dispatch('showShelf')
        await dispatch('hideOverlay');
    }
    else {
        dispatch('bindCartMouseMove');
    }
    if (!item.inCart) {
        let _item = _.find(state.items, {id:item.id});
        Vue.set(_item, 'inCart', true);
        _item.amount = !!item.amount ? item.amount : (!!_item.amount) ? _item.amount : 1;

        commit('ADD_TO_CART', _item);
    }
}
export const updateItemInCart = async ({commit, dispatch}, payload) => {
    let item = payload.item;
    // console.log("update item in cart>> ", item);
    commit('UPDATE_ITEM_IN_CART', item);
    if (!payload.dontShowCart) {
        setTimeout(function() {
            dispatch('showShelf')
        },100)
    }
}
export const removeFromCart = ({commit, dispatch}, item) => {
    commit('REMOVE_FROM_CART', item);
}
export const emptyCart = async ({commit, dispatch, state}) => {
    setTimeout(function() {
        return true
    }, 500);
    while (!!state.cart.items.length) {
        dispatch('removeFromCart', state.cart.items[0]);
    }
}
export const openItem = async({commit, dispatch}, item) => {
    commit('OPEN_ITEM', item);
    dispatch('showOverlay', 'item');
}
export const updateItemSize = ({commit}, size) => {
    commit('UPDATE_ITEM_SIZE', size);
}

// SAVE CART TO USER
export const saveCart = async ({commit, dispatch, state}, subtotal) => {
    if (!state.user.mid) {
        alert('You seem to be logged out')
    }
    let items = _.map(state.cart.items, item => {
        return {
            ItemId: item.id,
            Quintity: item.amount
        }
    });
    let mId = state.user.mid;
    let token = state.user.token;
    let cartData = { items, subtotal};
    let _data = {cartData: items, mId, token}
    let data = [btoa(JSON.stringify(_data)).toString()]


    axios.request({
        url: 'https://api.mis-implants.com/api/market',
        method: 'put',
        data,
        onUploadProgress: function (progressEvent) {
            // console.log("uploading... ", progressEvent);
        },
        onDownloadProgress: function (progressEvent) {
            // Do whatever you want with the native progress event
            // console.log("downloading... ", progressEvent);

        },
        maxContentLength: 2000,
    }).then(async response => {

        var cartID = response.data;
        //alert("cartID="+cartID);
        console.log("cart saved response>> ", response);
         console.log("cart saved response.data>> ", response.data);
        dispatch('changeShelfType', 'confirm');
        dispatch('downloadCart', cartID.toString());
        dispatch('bindCartMouseMove', await dispatch('emptyCart'));        
        //downloadExcel(1055)//<= should download cart
    }, error => {
        // console.log('[AXIOS|error] cart save error >> ', error);
    }, { headers: { 'Access-Control-Allow-Origin': '*', 'u': mId, 't': token } })

    // console.log("data > ", _data);
    // Vue.axios.post(api,_data).then(async (err, response) => {
    //     console.log("SAVE_CART, RESPONSE >> ", err, " :: ",  response);

    //     dispatch('changeShelfType', 'confirm');
    //     dispatch('bindCartMouseMove', await dispatch('emptyCart'));
    //     // sessionStorage.removeItem("_marketuser");
    // }, response => {
    //     // console.log('save cart error >> ', response);
    // })
}

/*
 -------------
    // HELPER FUNCTIONS
 -------------
*/
async function setItems(parsedItems, commit, getters) {
    let items = await mapItems(parsedItems, getters.isDevice, getters.isIE);
    // save items to session storage if available
    setToStorage(sessionStorage, '_marketitems', JSON.stringify(items), 10)
    commit('INIT_ITEMS', items);
}
async function loadItems() {
    return new Promise((resolve, reject) => {
        //let API = 'https://api.mis-implants.com/api/market?value=items';
        let API = 'https://api.mis-implants.com/api/market2/3'; //new version including links list 
        // SWorker.run(() => {
            // console.log("!!!! LOAD ITEMS");
            axios.get(API).then(function(response) {
                // console.log("api response > ", response);
                if (!!response && !!response.data) {
                    // console.log("ITEMS api response > ", response.data);
                    // postMessage(response.data);
                    resolve(response.data);
                }
            }, function(response) {
                resolve({ 'err': response});
            }, {headers: {'Access-Control-Allow-Origin': '*'}})
        // }).then(function(a,b,c) {console.log("respinse> ", a,b,c)}) // logs 'SWorker run 1: Function in other thread'
        // .catch(console.error)
        // let itemCacheWorker = new Worker('/dist/sw.js?' + new Date().getTime());
        // itemCacheWorker.postMessage(API)
        // itemCacheWorker.onmessage = function(e) {
        //     console.log("back from worker >> ", e);
        //     if (!!e && !!e.data) {
        //         resolve(e.data);
        //     }
        //     else {
        //         resolve()
        //     }
        // }
    });
    // return new Promise((resolve, reject) => {
    //     Vue.axios.post(GET_ITEMS, { id: 1}).then( async response => {
    //         resolve(response);
    //     }, response => {
    //         resolve({ 'err': response});
    //     }, {headers: {'Access-Control-Allow-Origin': '*'}})
    // })
}
async function loadItemsInBackground(cachedAmount, commit, getters) {
   let response = await loadItems();
   if (!!response.data && !!response.data.d) {
        let parsedItems = JSON.parse(response.data.d);
        console.log("loaded items in background complete: number of items>> ", parsedItems.length);
        if (cachedAmount<parsedItems.length) {
            setItems(parsedItems, commit, getters);
        }
   }
}

async function mapItems(items, isDevice,isIE) {
        // console.log('MAP ITEMS');
        let countryCodes = _.filter(_.compact(_.uniq(_.map(items, 'LangCC'))), r => { return _.trim(r)!=''}).join(';');
        // console.log('2 countryCodes > ', countryCodes);
        let item_country_flags = '';//await fetchFlagsForItems(countryCodes, isDevice, isIE);

        // console.log("rAW ITEMS  > ", items);
        let mappedItems = _.map(items, item => {
            let attachments = [];
            if (!!item.PrintCatalog) {
                let string = item.PrintCatalog,
                end = _.last(string.split('.'));

                if (end==='pdf') {
                    attachments.push({
                        type:"pdf",
                        label: "PDF File",
                        link: item.PrintCatalog
                    })
                }
                else if (end==='zip') {
                    attachments.push({
                        type:"download",
                        class: ["fas","fa-cloud-download-alt"],
                        label: "Download File",
                        link: item.PrintCatalog
                    })
                }
                else {
                    // Outer Link
                    attachments.push({
                        type:"link",
                        label: "View Item",
                        class: ["fas","fa-external-link-square-alt"],
                        link: item.PrintCatalog
                    })
                }

            }
            if (!!item.NewsLetter) {
                attachments.push({
                    type:"newsletter",
                    label: "Newsletter",
                    link: item.NewsLetter
                })
            }
            if (!!item.Presentation) {
                attachments.push({
                    type:"presentation",
                    label: "Presentation",
                    link: item.Presentation
                })
            }

            //attachments.push({type:"presentation",label: "Test1",link: "test1"});
            //attachments.push({type:"presentation",label: "Test2",link: "test2"});
            //attachments.push({type:"presentation",label: "Test3",link: "test3"});


            let catId = [item.CategoryId];
            let catNo = _.trim(item.CatalogNo);
            // let rootCatId = getRootId(item.CategoryId);
            if (!!item.TopSeller) {
                catId.push(111100);
            }
            // if (!!/simple/i.test(item.Name)) {
            //     catId.push(111101);
            // }
            

            //OLD METHOD FOR FIXING IMG NAMES
            /*
            var imgPath = "/static/img/items/"+catNo.replace(/\s/g, '_').replace(/\'/g, '').
            replace(/b\+/gi, 'BPLUS_').
            replace(/LAN\+/gi, 'LANPLUS_').
            replace(/LANCE\+/gi, 'LANCEPLUS_').            
            replace(/lance\+/gi, 'LANCEPLUS_') + ".png";
            */

            //NEW METHOD, TAKE THE IMAGE NAME FROM THE SPECIFIC DB COL "ImgName" 
            //THE ImgName PROP IN THE DB ALREADY CONTAINS THE FILE EXTENTION
            let ImgName = _.trim(item.ImgName);
            var imgPath = "/static/img/items/"+ImgName;
            //imgPath = "https://market.mis-implants.com"+imgPath;//test<<<<

            //if(item.Id==1749)
            //{
                //alert(item.files);
            //}

            return {
                id: item.Id,
                catId,
                description: item.Description,
                image: imgPath,
                catNo,
                name: item.Name,
                price:item.Price || 0,
                flag: !!item_country_flags ? item_country_flags[item.LangCC] || null : null,
                attachments,
                links:item.files,
                sort: item.Sort,
                lang: item.LangCC ? item.LangCC : ''
            }
        })
        // console.log('mapped items >> ', mappedItems);
        return _.sortBy(mappedItems, 'sort');
}

async function fetchFlagsForItems(countryCodes, isDevice, isIE) {
    // console.log('fetchFlagsForItems >> isIE?? ', isIE);
    let flagCollection = {};
    if (isDevice || isIE) {
        let ccArray = countryCodes.split(';');
        // console.log("countryCodes .. ", countryCodes);
        for (var i = 0; i< ccArray.length; i++ ) {
            let cc = ccArray[i];
            flagCollection[cc] = "/img/flags/"+cc+".png"; //"static/img/flags/"+cc+".png";
        }
        // console.log('flagCollection >> ', flagCollection);
        return flagCollection;
    }
    else {
        let api = "https://restcountries.eu/rest/v2/alpha?codes=" + countryCodes;
        return new Promise((resolve, reject) => {
            // console.log("restcountries api > ", api);
            Vue.axios.get(api).then(response => {
                if (!!response.data) {
                    for (var i = 0; i < response.data.length; i++) {
                        let c = response.data[i];
                        // console.log("C >> ",c);
                        if (!!c) {
                            flagCollection[c.alpha2Code] = c.flag
                        }
                    }
                }
                resolve(flagCollection);
            }).catch(function (error) {
                // console.log("in catch, error : ", error);
                resolve(null)
            });
        });
    }
}


async function fetchUserFlag(country) {
    return new Promise((resolve, reject) => {
        let api = "https://restcountries.eu/rest/v2/name/"+country;
        Vue.axios.get(api).then(response => {
            if (!!response.data.length && !!response.data[0].flag) {
                resolve(response.data[0].flag);
            } else {
                resolve(null);
            }
        }), response => {
            resolve(null);
        }
    })
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
export const downloadCart =  ({commit}, id) => 
{
    let _cart = getFromStorage(localStorage, "_marketcart");
    _cart = JSON.parse(_cart);
    var encodedData = JSON.stringify(_cart);
    
    let url = "https://api.mis-implants.com/api/marketDownloadOrder";
    fetch(url,
    {
        headers: {'pragma': 'no-cache','cache-control': 'No-Store','Content-Type': 'application/json','Access-Control-Allow-Origin': '*','token':vm.user.token,'mid':vm.user.mid},
        method: 'post',mode: 'cors',
        cache: 'no-cache',
        body: encodedData
    }).then(function(response){
        vm.loading = false;
        return response.json();
    }).then(function(response){
        vm.loading = false;
        var fileToken = response;
        var downloadApiURL = "https://api.mis-implants.com/api/xDownloadReport/"+fileToken;
        window.location =  downloadApiURL;
    }); 

    //window.open(API, '_blank');
    /*
    axios.get(API).then(response => x
        {
            return response;
        }, response => {
            return { 'err': response }
    }, { headers: { 'Access-Control-Allow-Origin': '*' } })
    */
}
    //return Vue.axios
        //.get('https://api.mis-implants.com/api/marketDownloadOrder/'+id)
        //.then(response => (this.info = response))

    async function fetchItemsOrdered(id) {
        return Vue.axios.post(GET_MEMBER_CARTS, {MemberID:id}).then(async response => {
            if (!!response && !!response.data.d) {
                let res = JSON.parse(response.data.d);
                let itemIds = _.uniq(_.map(_.flatMap(res, 'OrderItems'), 'ItemId'));
                return itemIds;
            }
        }, response => {
            // console.log('GET_MEMBER_CARTS error >> ', response);
            return [];
        })
    }



/* 
async function fetchItemsOrdered(id) {
    return Vue.axios.post(GET_MEMBER_CARTS, {MemberID:id}).then(async response => {
        if (!!response && !!response.data.d) {
            let res = JSON.parse(response.data.d);
            let itemIds = _.uniq(_.map(_.flatMap(res, 'OrderItems'), 'ItemId'));
            return itemIds;
        }
    }, response => {
        // console.log('GET_MEMBER_CARTS error >> ', response);
        return [];
    })
}
 */

function initIdleTimer() {
    // TODO:: kick idle user out after XX number if minutes...
}
// LOCAL STORAGE
// CHECK SUPPORT
function storageSupport(){
    try {
        return 'sessionStorage' in window && window['sessionStorage'] !== null;
    } catch(e) {
        return false;
    }
}

// FETCH FROM STORAGE
function getFromStorage(storageType, key) {
    if (storageSupport()) {
        // checkStorageExpiration(storageType, key);
        return storageType.getItem(key) || null
    }
    return null;
}
// SAVE TO STORAGE
function setToStorage(storageType, key, data, daysToExpire) {
    storageSupport() && storageType.setItem(key, data);
    // setStorageExpiration(storageType, key, daysToExpire);
}

// CHECK EXPIRATION
function checkStorageExpiration(storageType, key) {
    let curdate = new Date(),
    date = new Date(storageType.getItem(key+'_expiration'));
    if (!!date && curdate>date) {
        removeFromStorage(storageType, key)
    }
}
// SET EXPIRATION
function setStorageExpiration(storageType, key, days=10) {
    let expiredate = new Date();
    expiredate.setDate(expiredate.getDate() + days);
    storageType.setItem(key+'_expiration', expiredate);
}

// REMOVE FROM STORAGE
function removeFromStorage(storageType, key) {
    storageType.removeItem(key);
    storageType.removeItem(key+"_expiration");
}

// RESTART CACHING
function clearCache() {
    removeFromStorage(sessionStorage, "_marketcategories");
    removeFromStorage(sessionStorage, "_marketitems");
}

window._cc = clearCache;